import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'
export default {
    path: '/testBaseManage',
    name: 'TestBaseManage',
    meta: {
        title: '教研管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/testBaseManage/checkedTest',
    children: [
        {
            path: 'radioTest',
            name: 'radioTest',
            meta: {
                title: '单选题列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/testBaseManage/radioTest/Index.vue'], resolve),

        },
        {
            path: 'radioTest',
            name: 'TadioTest',
            meta: {
                title: '单选题列表',
                keepAlive: false
            },
            component: Empty,
            redirect: '/testBaseManage/radioTest/RadioTestA1',
            children: [{
                path: 'radioTestA1',
                name: 'RadioTestA1',
                meta: {
                    title: '编辑试题',
                    keepAlive: false
                },
                component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1.vue'], resolve),

            },
            {
                path: 'radioTestA3',
                name: 'RadioTestA3',
                meta: {
                    title: '编辑试题',
                    keepAlive: false
                },
                component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3.vue'], resolve),

            },
            {
                path: 'radioTestB',
                name: 'radioTestB',
                meta: {
                    title: '编辑试题',
                    keepAlive: false
                },
                component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestB.vue'], resolve),

            },]
        },
        {
            path: 'checkedTest',
            meta: {
                title: '题库',
                keepAlive: false
            },
            component: resolve => require(['@/views/testBaseManage/checkedTest/Index.vue'], resolve),
        },
        {
            path: 'checkedTest',
            meta: {
                title: '题库',
                keepAlive: false
            },
            component: Empty,
            children: [{
                path: 'checkedTestA1/:type',
                name: 'CheckedTestA1',
                meta: {
                    title: '编辑试题',
                    keepAlive: false
                },
                component: resolve => require(['@/views/testBaseManage/checkedTest/CheckedTestA1.vue'], resolve),

            },
                {
                    path: 'checkedTestA4/:type',
                    name: 'CheckedTestA4',
                    meta: {
                        title: '编辑试题',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/testBaseManage/checkedTest/CheckedTestA4.vue'], resolve),

                },
                {
                    path: 'checkedTestB/:type',
                    name: 'CheckedTestB',
                    meta: {
                        title: '编辑试题',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/testBaseManage/checkedTest/CheckedTestB.vue'], resolve),

                }

            ]
        }
    ]
}
